import { Grid } from '@material-ui/core';
import { Field } from 'redux-form';
import i18n from '../../../i18n';
import { SwitchControlField } from 'components/SwitchControl/SwitchControl';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
    registrationSettingsPaymentCardSelector,
    registrationSettingsPaymentCashSelector,
} from 'state/registration/selector';
import { Form } from 'forms/types';
import { Text, TextTypography } from 'components/Text/Text';
import { makeStyles } from '@material-ui/core/styles';
import { DialogNew } from '../../components/Dialog/DialogNew';
import { isUIEnabledSelector } from '../../state/app/selectors';

export interface PaymentFormData {
    atStore: boolean;
    atDelivery: boolean;
}

const useStyles = makeStyles(theme => ({
    container: {
        paddingBottom: 52,
    },
    text: {
        paddingLeft: theme.spacing(1),
    },
    buttonContainer: {
        paddingBottom: theme.spacing(1),
    },
    item: {
        whiteSpace: 'nowrap',
    },
}));

export const DEFAULT_PAYMENT_FORM_DATA = { atStore: true, atDelivery: true };

export const PaymentFormComponent = (props: any) => {
    const { form, handleSubmit, onClose, initialize } = props;
    const { t } = i18n.useTranslation();
    const classes = useStyles();
    const selector =
        form === Form.REGISTRATION_CASH_FORM
            ? registrationSettingsPaymentCashSelector
            : registrationSettingsPaymentCardSelector;
    const paymentFormData = useSelector(selector);

    const handleClose = useCallback(() => {
        if (paymentFormData.atDelivery === null) {
            initialize(DEFAULT_PAYMENT_FORM_DATA);
        } else {
            initialize(paymentFormData);
        }
        onClose();
    }, [paymentFormData, initialize, onClose]);

    const isUIEnabled = useSelector(isUIEnabledSelector);

    return (
        <DialogNew
            title={t(`onboarding:settings.${form === Form.REGISTRATION_CARD_FORM ? 'cardDialog' : 'cashDialog'}`)}
            width={423}
            onClose={handleClose}
            onSubmit={handleSubmit}
            leftButton={t('common:settings.closeButton')}
            rightButton={t('onboarding:settings:saveButton')}
            isUIEnabled={isUIEnabled}
        >
            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                <div className={classes.container}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} className={classes.text}>
                            <Text typography={TextTypography.PARA}>
                                {t(
                                    `onboarding:settings.${
                                        form === Form.REGISTRATION_CARD_FORM ? 'cardPaymentText' : 'cashPaymentText'
                                    }`,
                                )}
                            </Text>
                        </Grid>
                        <Grid item xs={12}>
                            <Field
                                className={classes.item}
                                name="atStore"
                                component={SwitchControlField}
                                label={t('onboarding:settings:atStore')}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Field
                                className={classes.item}
                                name="atDelivery"
                                component={SwitchControlField}
                                label={t('onboarding:settings:atDelivery')}
                            />
                        </Grid>
                    </Grid>
                </div>
            </form>
        </DialogNew>
    );
};
